import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';

const NavbarVerticalMenuItem = ({ route }) => {
  return (
      <Flex alignItems="center">
        {route.icon && (
            <span className="nav-link-icon">
          {typeof route.icon === 'string' ? (
              <i className={`fas fa-${route.icon}`} />
          ) : (
              <FontAwesomeIcon icon={route.icon} />
          )}
        </span>
        )}
        <span className="nav-link-text ps-1">{route.name}</span>
        {route.badge && (
            <SubtleBadge pill bg={route.badge.type} className="ms-2">
              {route.badge.text}
            </SubtleBadge>
        )}
      </Flex>
  );
};

// prop-types
const routeShape = {
    active: PropTypes.bool,
    name: PropTypes.string.isRequired,
    to: PropTypes.string,
    icon: PropTypes.any
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
